<template>
  <ons-page id="signup">
    <v-ons-progress-bar indeterminate class="page-progress" v-show="loading"></v-ons-progress-bar>
    <div class="center-box full-height">
      <form action="" class="login-content">
        <div class="tabs tabs-login tabs-round tabbar tabbar--top" data-control="#tabs-content-signup">
          <label class="tabbar__item" data-index="1">
          <input type="radio" name="tab-signup" checked="checked">
          <button class="tabbar__button">
            {{ $t("signup.nav.email") }}
          </button>
          </label>
          <label class="tabbar__item" data-index="2">
          <input type="radio" name="tab-signup" >
          <button class="tabbar__button">
            {{ $t("signup.nav.sso") }}
          </button>
          </label>
        </div>
        <div class="tabs-slider tabs-slider-2" id="tabs-content-signup">
          <div>
            <div class="form-group">
              <div class="form-row">
                <v-ons-input id="signup-name" modifier="underbar" :placeholder="$t('signup.name')" float v-model="name"></v-ons-input>
                <div class="message-error"
                  v-for="error in errors.name || []"
                >{{ error }}</div>
              </div>
              <div class="form-row">
                <v-ons-input id="signup-email" type="email" modifier="underbar" :placeholder="$t('signup.email')" float v-model="email"></v-ons-input>
              </div>
                <div class="message-error"
                  v-for="error in errors.email || []"
                >{{ error }}</div>
              <div class="form-row">
                <v-ons-input id="signup-password" type="password" modifier="underbar" :placeholder="$t('signup.password')" float v-model="password"></v-ons-input>
              </div>
                <div class="message-error"
                  v-for="error in errors.password || []"
                >{{ error }}</div>
              <div class="form-row">
                <v-ons-input id="signup-confirm-password" type="password" modifier="underbar" :placeholder="$t('signup.password_confirm')" float v-model="passwordConfirmation"></v-ons-input>
                <div class="message-error"
                  v-for="error in errors.password_confirmation || []"
                >{{ error }}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="form-row center-align">
                <v-ons-button class="" modifier="large" @click="signUp()">{{ $t("signup.signup") }}</v-ons-button>
              </div>
              <div class="small center-align">
                <a class="button--quiet button--small js-newpage" @click.prevent="navigatorPop()" modifier="quiet small" href="">{{ $t("signup.login") }}</a>
              </div>
            </div>
          </div>
          <div>
            <ul class="no-bullet">
              <li>
                <ons-button class="facebook" modifier="large"
                  :disabled="loading"
                  @click="signInOrSignUpWith('Facebook')"
                >
                  <span class="icon-sm">
                    <icon-facebook />
                  </span>
                  {{ $t("login.login_with_fb") }}
                </ons-button>
              </li>
              <li>
                <v-ons-button class="google" modifier="large"
                  :disabled="loading"
                  @click="signInOrSignUpWith('Google')"
                >
                  <span class="icon-sm">
                    <icon-google />
                  </span>
                  {{ $t("login.login_with_google") }}
                </v-ons-button>
              </li>
              <li v-show="!$isStandalone || isIOS">
                <v-ons-button class="apple" modifier="large"
                  :disabled="loading"
                  @click="signInOrSignUpWith('Apple')"
                >
                  <span class="icon-sm">
                    <icon-apple />
                  </span>
                  {{ $t("login.login_with_apple") }}
                </v-ons-button>
              </li>
            </ul>
          </div>
        </div>
      </form>
    </div>
  </ons-page>
</template>

<script>
import CurrentUser from '@/models/CurrentUser';
import SignInOrSignUpWith from '@/mixins/SignInOrSignUpWith';

export default {
  name: 'signup',
  props: ['allowPop'],
  mixins: [SignInOrSignUpWith],

  data() {
    return {
      name: null,
      email: null,
      password: null,
      passwordConfirmation: null,
      loading: false,
      errors: {},
      isIOS: this.$ons.platform.isIOS() || this.$ons.platform.isIPadOS(),
    };
  },

  methods: {
    signUp() {
      this.errors = {};
      let hasError = false;
      // validate
      if (!this.name) {
        this.errors.name = [this.$t("signup.errors.name_empty")];
        hasError = true;
      }
      if (!this.email) {
        this.errors.email = [this.$t("signup.errors.email_empty")];
        hasError = true;
      }
      if (!this.password) {
        this.errors.password = [this.$t("signup.errors.pw_empty")];
        hasError = true;
      }
      if (!this.passwordConfirmation) {
        this.errors.password_confirmation = [this.$t("signup.errors.pw_confirm_empty")];
        hasError = true;
      }
      if (hasError) { return; }
      if (this.password !== this.passwordConfirmation) {
        this.errors.password_confirmation = [this.$t("signup.errors.pw_not_match")];
        hasError = true;
      }
      if (hasError) { return; }

      let that = this;
      this.loading = true;
      CurrentUser.registrationCreate({
        name: this.name,
        email: this.email,
        password: this.password,
        passwordConfirmation: this.passwordConfirmation
      }).then((result) => {
        return this.$store.dispatch('currentUser/signIn', { email: this.email, password: this.password });
      }).then(() => {
        if (!this.allowPop) {
          this.navigatorResetMain({}, this.$t("messages.create_acc_confirm"));
        } else {
          this.navigatorPop({steps: 2});
        }
        this.setupPushNotification();
      }).catch(function (error) {
        if (error.response && error.response.status === 422) {
          for (var key in error.response.data.errors) {
            that.errors[key] = [that.$t(`${key} ${error.response.data.errors[key]}`)];
          }
          that.$forceUpdate();
          that.showCheckErrorsToast();
        } else {
          console.log(error);
          that.showSomethingWrongToast();
        }
      }).finally(() => {
        this.loading = false;
      });
    },
  },

  mounted() {
    this.loadTabs(this.$el);
  },
};
</script>
